import {
	LINK_PAYMENT_SUCCESSFULLY,
	LINK_PAYMENT_FAILED
} from '../Actions/types';

const INITIAL_STATE = {
	paymentLink: {},
	loading: false,
	error: '',
}

const payReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case LINK_PAYMENT_SUCCESSFULLY:
			return {...state, paymentLink: action.payload}
		case LINK_PAYMENT_FAILED:
			return { ...state, error: action.data.error, loading: true }
		default:
			return { ...state }
	}
}

export default payReducer;